module.exports = __webpack_public_path__ + "media/images/proof_links/colored/wiki-d207a1c3303e28572b153120f8eaf3f0.svg";